var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgZoomOut(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3997 13.6002C17.5391 13.6002 13.5987 17.5405 13.5987 22.4012C13.5987 27.2618 17.5391 31.2022 22.3997 31.2022C27.2604 31.2022 31.2007 27.2618 31.2007 22.4012C31.2007 17.5405 27.2604 13.6002 22.3997 13.6002ZM11.9985 22.4012C11.9985 16.6568 16.6553 12 22.3997 12C28.1441 12 32.8009 16.6568 32.8009 22.4012C32.8009 28.1456 28.1441 32.8024 22.3997 32.8024C16.6553 32.8024 11.9985 28.1456 11.9985 22.4012Z",
    fill: "#1D2129"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.0348 29.0351C29.3472 28.7226 29.8538 28.7226 30.1663 29.0351L35.7669 34.6357C36.0793 34.9482 36.0793 35.4548 35.7669 35.7672C35.4544 36.0797 34.9478 36.0797 34.6354 35.7672L29.0348 30.1666C28.7223 29.8541 28.7223 29.3475 29.0348 29.0351Z",
    fill: "#1D2129"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3993 22.4018C18.3993 21.9599 18.7575 21.6017 19.1994 21.6017H25.6001C26.042 21.6017 26.4002 21.9599 26.4002 22.4018C26.4002 22.8436 26.042 23.2019 25.6001 23.2019H19.1994C18.7575 23.2019 18.3993 22.8436 18.3993 22.4018Z",
    fill: "#1D2129"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomOut);
export default __webpack_public_path__ + "static/media/zoom-out.ff330323acdfa66736da06852dca058f.svg";
export { ForwardRef as ReactComponent };